import React, { createContext, useState, useContext } from 'react';

// Create the context
const BreadcrumbContext = createContext();

// Custom hook to use the breadcrumb context
export const useBreadcrumb = () => {
    return useContext(BreadcrumbContext);
};

// Breadcrumb provider to wrap around components
export const BreadcrumbProvider = ({ children }) => {
    const [breadcrumb, setBreadcrumb] = useState([]);

    const updateBreadcrumb = (newBreadcrumb) => {
        setBreadcrumb(newBreadcrumb);
    };

    return (
        <BreadcrumbContext.Provider value={{ breadcrumb, updateBreadcrumb }}>
            {children}
        </BreadcrumbContext.Provider>
    );
};
